import Component from "../core/Component";
import Flickity from "flickity";
import throttle from "lodash/throttle";
import debounce from "lodash/debounce";
import enquire from "enquire.js";
import { queries } from "../core/config";
import { toggleClass } from "../utils/dom";

export const STATUS = {
   READY: "is-ready",
};

export default class Slider extends Component {
   constructor(element) {
      super(element);
      this.moveState;
      this.ref = {
         wrap: null,
         slides: [],
         index: null,
         buttonNext: null,
         buttonPrev: null,
      };
      this.accordContents = document.querySelectorAll(".Accord-content");
      this.autoPlaySpeed = 5000;
      if (this.element.dataset.speed) {
         this.autoPlaySpeed = parseInt(this.element.dataset.speed);
      }

      this.current = 0;
      this.timer = null;

      this.movingEnabled = element.classList.contains("moveComponents");

      this.dragging = false;
      this.isDesktop = false;

      this.enquireHandler = {
         match: () => {
            this.isDesktop = true;
         },
         unmatch: () => {
            this.isDesktop = false;
         },
      };

      this.handleResize = throttle(::this.handleResize, 100);
      this.handleWindowBlur = debounce(::this.handleWindowBlur, 50);
      this.handleWindowFocus = debounce(::this.handleWindowFocus, 50);
   }

   prepare() {
      enquire.register(queries.largeUp, this.enquireHandler);
      window.addEventListener("resize", this.handleResize);

      if (!this.isDesktop) {
         if (this.ref.slides.length > 1) {
            this.element.classList.add(STATUS.READY);

            if (this.movingEnabled) this.moveComponents("slider");

            this.flickity = new Flickity(this.ref.wrap, {
               cellSelector: ".Slider-item",
               prevNextButtons: false,
               wrapAround: true,
               pageDots: true,
               resize: true,
            });

            this.flickity.on("select", ::this.handleSelect);
            this.flickity.on("dragStart", ::this.handleDragStart);
            this.flickity.on("dragEnd", ::this.start);
            this.flickity.on("settle", ::this.handleSettle);

            this.flickity.on("change", (itemIndex) => {
               this.getElement().dispatchEvent(new CustomEvent("itemOpened", { detail: itemIndex }));
            });

            this.element.addEventListener("mouseenter", ::this.stop);
            this.element.addEventListener("mouseleave", ::this.start);
            this.element.addEventListener("click", ::this.handleClick);

            //window.addEventListener("resize", this.handleResize);
            window.addEventListener("blur", this.handleWindowBlur);
            window.addEventListener("focus", this.handleWindowFocus);

            this.handleSelect(0);
            this.start();
         }
      }
   }

   moveComponents(direction) {
      const accords = document.querySelectorAll(".Accord-item");
      const slides = document.querySelectorAll(".AccordionSlider-item");
      const components = document.querySelectorAll(".slider-component");
      let wrapper = document.createElement("div");
      wrapper.classList.add("component-wrapper");

      if (direction === "slider" && this.moveState != direction) {
         accords.forEach((item, index) => {
            let x = wrapper.cloneNode(true);
            x.appendChild(components[index]);
            item.prepend(x);
         });
      }
      if (direction === "accordion" && this.moveState != direction) {
         slides.forEach((item, index) => {
            item.prepend(components[index]);
         });
         const usedWrappers = document.querySelectorAll(".component-wrapper");
         if (usedWrappers) usedWrappers.forEach((item) => item.remove());
      }
      this.moveState = direction;
   }

   destroy() {
      this.stop();
      //window.removeEventListener("resize", this.handleResize);
      window.removeEventListener("blur", this.handleWindowBlur);
      window.removeEventListener("focus", this.handleWindowFocus);
      enquire.unregister(queries.largeUp, this.enquireHandler);
   }

   handleWindowFocus(event) {
      this.start();
   }

   handleWindowBlur(event) {
      this.stop();
   }

   handleResize() {
      this.resize();
   }

   handleClick(event) {
      if (this.dragging) {
         event.stopPropagation();
         event.preventDefault();
      }
   }

   handleSelect(current) {
      if (this.ref.index) {
         this.ref.index.textContent = current < 9 ? `0${current + 1}` : current + 1;
      }
   }

   handleDragStart() {
      this.dragging = true;
      this.stop();
   }

   handleSettle() {
      this.dragging = false;
   }

   resize() {
      if (window.innerWidth >= 1024) {
         if (this.movingEnabled) this.moveComponents("accordion");
         this.accordBodies("shrink");
         if (this.flickity) {
            this.flickity.destroy();
         }
      } else {
         this.isDesktop = false;
         if (this.movingEnabled) this.moveComponents("slider");
         this.prepare();
         this.accordBodies("expand");
         if (this.flickity) {
            this.flickity.resize();
         }
      }
   }

   accordBodies(state) {
      if (state === "expand") this.accordContents.forEach((item) => (item.style.height = ""));
      if (state === "shrink") {
         this.accordContents.forEach((item) => {
            if (item.parentNode.classList.contains("is-active")) {
               item.style.height = "";
               return;
            }
            item.style.height = "0px";
         });
      }
   }

   stop() {
      clearInterval(this.timer);
   }

   start() {
      this.stop();
      this.timer = setInterval(::this.next, this.autoPlaySpeed);
   }

   next() {
      this.flickity.next();
   }
}
